// This function is used to validate the password for the user's account with a specific set of rules.
// It is used in the signup and change password screens.
export const getPasswordValidationError = (password: string, comparePassword?: string): string => {
  if (!!comparePassword && password !== comparePassword) return "passwords do not match"
  if (password.length === 0) return "can't be blank"
  if (password.length < 8) return "must be at least 8 characters"
  if (password.length > 128) return "must be at most 128 characters"
  if (!/[a-z]/.test(password)) return "must contain at least one lowercase character"
  if (!/[A-Z]/.test(password)) return "must contain at least one uppercase character"
  const specialCharacters = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/
  if (!specialCharacters.test(password)) return "must contain at least one special character"
  return ""
}
